import { Component, ElementRef, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatPaginator, MatSort } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';
import { fuseAnimations } from '../../../../../core/animations';
import { TranslationService } from '../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../services/sweet-alert/sweet-alert.service';
import { ExamBoardService } from '../../../../services/exam-board/exam-board.service';
import { ExamBoard } from '../../../../models/exam-boards/exam-board';
import { ShiftService } from '../../../../services/shifts/shift.service';
import { Shift } from '../../../../models/shifts/shift';
import { ActivatedRoute } from '@angular/router';
import { AddEditExamBoardComponent } from './components/add-edit-exam-board/add-edit-exam-board.component';
import { Router } from '@angular/router';

@Component({
    selector: 'fuse-exam-boards',
    templateUrl: './exam-boards.component.html',
    styleUrls: ['./exam-boards.component.scss'],
    animations: fuseAnimations
})
export class ExamBoardsComponent implements OnInit, OnDestroy, AfterViewInit {
    @BlockUI('tracker') blockUI: NgBlockUI;
    displayedColumns = ['Shift', 'Date', 'Time', 'Subjects', 'Actions'];
    examBoardDatabase: ExamBoardDatabase;
    dataSource: ExamBoardDataSource | null;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    examCallId: number;
    schoolYearId: number;
    shifts: Shift[] = [];
    shiftSelected: number;

    constructor(
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private examBoardService: ExamBoardService,
        private shiftService: ShiftService,
        private route: ActivatedRoute,
        private router: Router,
        public dialog: MatDialog
    ) { }

    ngOnInit() {        
        this.route.params.subscribe(params => {
            this.examCallId = +params['examCallId'];
            this.schoolYearId = +params['schoolYearId'];

            this.shiftService.getAll().subscribe(res => {
                this.shifts = res;
            });

        });
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.loadData();
        });
    }

    loadData() {
        //if (!this.paginator || !this.sort) return;
        console.log("Loading data with shift: ", this.examCallId);
        this.examBoardDatabase = new ExamBoardDatabase(this.examBoardService, this.examCallId, this.shiftSelected);
        console.log(this.dataSource)
        this.dataSource = new ExamBoardDataSource(this.examBoardDatabase, this.paginator, this.sort);
    }

    refreshData() {
        this.loadData();
    }

    onShiftChange(id: number) {
        this.shiftSelected = id;
        this.loadData();
    }


    add() {
        const dialogRef = this.dialog.open(AddEditExamBoardComponent, {
            panelClass: 'add-edit-exam-board-dialog',
            width: '600px',
            data: {
                mode: 'add',
                examBoard: new ExamBoard(),
                examCallId: this.examCallId,
                schoolYearId: this.schoolYearId,
                shifts: this.shifts
            }
        });

        dialogRef.afterClosed().subscribe(res => {
            if (res) this.loadData();
        });
    }

    edit(examBoard: ExamBoard) {
        const dialogRef = this.dialog.open(AddEditExamBoardComponent, {
            panelClass: 'add-edit-exam-board-dialog',
            width: '600px',
            data: {
                mode: 'edit',
                examBoard: Object.assign({}, examBoard),
                examCallId: this.examCallId,
                schoolYearId: this.schoolYearId,
                shifts: this.shifts
            }
        });

        dialogRef.afterClosed().subscribe(res => {
            if (res) this.loadData();
        });
    }

    delete(examBoard: ExamBoard) {
        this.sweetAlertService.question(
            this.translationService.confirmation,
            this.translationService.deletionConfirmationQuestion,
            this.translationService.yes,
            this.translationService.no,
            () => {
                this.blockUI.start(this.translationService.loading);
                this.examBoardService.delete(examBoard.Id).subscribe(res => {
                    this.blockUI.stop();
                    if (res.ResultCode === 1) {
                        this.sweetAlertService.success(this.translationService.success, this.translationService.deletedCorrectly, null);
                        this.loadData();
                    }
                });
            }
        );
    }

    goToExamCalls() {
        // Regresa a la pantalla anterior (exam-calls). Si se necesita navegación explícita,
        // reemplazar por Router.navigate(['/path/to/exam-calls', ...params])
        this.router.navigate(['/pages/management/exam-calls']);
    }

    ngOnDestroy() { }
}

export class ExamBoardDatabase {
    dataChange: BehaviorSubject<ExamBoard[]> = new BehaviorSubject<ExamBoard[]>([]);
    get data(): ExamBoard[] { return this.dataChange.value; }

    constructor(private examBoardService: ExamBoardService, examCallId: number, shiftId: number) {
        if (examCallId) {
            this.examBoardService.getByExamCall(examCallId, shiftId).subscribe(res => {
                // Normaliza la respuesta: puede venir como array directo o como { Result: [...] } u otras variantes.
                let items: ExamBoard[] = [];
                if (Array.isArray(res)) {
                    items = res;
                } else if (res && Array.isArray((res as any).Result)) {
                    items = (res as any).Result;
                } else if (res && Array.isArray((res as any).data)) {
                    items = (res as any).data;
                } else if (res) {
                    // Fallback: envolver un único objeto en array (evita crash si backend devuelve un solo registro)
                    items = [].concat(res as any);
                }
                this.dataChange.next(items);
            });
        }
    }
}

export class ExamBoardDataSource extends DataSource<any> {
    filteredData: ExamBoard[] = [];
    renderedData: ExamBoard[] = [];

    constructor(
        private _database: ExamBoardDatabase,
        private _paginator: MatPaginator,
        private _sort: MatSort
    ) {
        super();
    }

    connect(): Observable<ExamBoard[]> {
        const displayDataChanges = [
            this._database.dataChange,
            this._sort.sortChange,
            this._paginator.page
        ];

        return Observable.merge(...displayDataChanges).map(() => {
            if (!this._database.data) return [];

            this.filteredData = this._database.data.slice();

            const sortedData = this.sortData(this.filteredData.slice());
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize);
            return this.renderedData;
        });
        // return Observable.merge(...displayDataChanges).map(() => {
        //     if (!this._database.data) return [];

        //     this.filteredData = this._database.data.slice();

        //     const sortedData = this.sortData(this.filteredData.slice());
        //     const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
        //     this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize);
        //     return this.renderedData;
        // });
    }

    disconnect() { }

    sortData(data: ExamBoard[]): ExamBoard[] {
        if (!this._sort.active || this._sort.direction === '') return data;

        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';

            switch (this._sort.active) {
                case 'Shift': [propertyA, propertyB] = [a.ShiftDescription, b.ShiftDescription]; break;
                case 'Date': [propertyA, propertyB] = [a.Date.toString(), b.Date.toString()]; break;
                case 'Time': [propertyA, propertyB] = [a.Time, b.Time]; break;
            }

            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/exam-boards/exam-boards.component.ts